import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import moment from 'moment';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { getResume2Token, getUserInfoCompanyId, getval2Token } from '../../../Login/Auth';
import { OtherData_base, ContractorResumeBase } from '../ContractorResume/ContractorResumeBase';
import { OtherData_family, ContractorResumeFamily } from '../ContractorResume/ContractorResumeFamily';
import { OtherData_education, ContractorResumeEducation } from '../ContractorResume/ContractorResumeEducation';
import { OtherData_workExperiences, ContractorResumeWorkExperiences } from '../ContractorResume/ContractorResumeWorkExperiences';
import { OtherData_attachment, ContractorResumeAttachment } from '../ContractorResume/ContractorResumeAttachment';
import { OtherData_payrollMethod, ContractorResumePayrollMethod } from '../ContractorResume/ContractorResumePayrollMethod';
import { RespResumeOtherData, ReqResumeEdit, ReqResumeDetail, RespResumeDetail } from '../../../../item/ItemResume';
import { api_contractorResumeUpdate } from '../../../../api/apiResume';
import { api_getEmployeeResumeDetail } from '../../../../api/apiEmployeeResume';
import { ReqEmployeeResumeDetail, RespEmployeeResumeDetail } from '../../../../item/ItemEmployeeResume';
import { EmployeeResumeJobInfo } from './EmployeeResumeJobInfo';

export function EmployeeResumeEdit({ id, setIsLoading, isEdit = false }) {
    const [companyId] = useState(getUserInfoCompanyId())
    const [tokenId, setTokenId] = useState("")
    const [accountId, setAccountId] = useState("")
    const [idNumber, ssetIdNumber] = useState("")
    const [birthday, setBirtyday] = useState("")
    const [detail, setDetail] = useState({})
    const [base, setBase] = useState({})
    const [family, setFamily] = useState({})
    const [education, setEducation] = useState({})
    const [payrollMethod, setPayrollMethod] = useState({})
    const [attachment, setAttachment] = useState({})
    const [workExperiences, setWorkExperiences] = useState({})

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var rId = getval2Token("accountId", id)
            console.log(rId)
            // var rId = getResume2Token(id)
            setAccountId(rId)
            setTokenId(id)
            var mReqResumeDetail = new ReqEmployeeResumeDetail({
                companyId,
                accountId: rId,
                tokenId: id
            })
            getDetail(mReqResumeDetail)
        }
    }, [id])

    function getDetail(mReqResumeDetail) {
        setIsLoading(true)
        console.log(mReqResumeDetail)
        api_getEmployeeResumeDetail({
            mReqResumeDetail,
            success: (result) => {
                console.log(result)
                if (result.info === undefined) {
                    setIsLoading(false)
                    return
                }
                var mRespResumeDetail = new RespEmployeeResumeDetail({})
                mRespResumeDetail.fromJson(result.info)
                setAccountId(mRespResumeDetail.accountId)
                ssetIdNumber(mRespResumeDetail.idNumber)
                setDetail(mRespResumeDetail)
                console.log(mRespResumeDetail)
                var base
                if(mRespResumeDetail.resumeDatas !== undefined && mRespResumeDetail.resumeDatas.base !== undefined){
                    base = mRespResumeDetail.resumeDatas.base
                }
                setBase(setResumeOtherData({
                    accountId: mRespResumeDetail.accountId,
                    resumeKey: OtherData_base,
                    resumeData: base
                }))
                var family
                if(mRespResumeDetail.resumeDatas !== undefined && mRespResumeDetail.resumeDatas.family !== undefined){
                    family = mRespResumeDetail.resumeDatas.family
                }
                setFamily(setResumeOtherData({
                    accountId: mRespResumeDetail.accountId,
                    resumeKey: OtherData_family,
                    resumeData: family
                }))
                var education
                if(mRespResumeDetail.resumeDatas !== undefined && mRespResumeDetail.resumeDatas.education !== undefined){
                    education = mRespResumeDetail.resumeDatas.education
                }
                setEducation(setResumeOtherData({
                    accountId: mRespResumeDetail.accountId,
                    resumeKey: OtherData_education,
                    resumeData: education
                }))
                var workExperiences
                if(mRespResumeDetail.resumeDatas !== undefined && mRespResumeDetail.resumeDatas.workExperiences !== undefined){
                    workExperiences = mRespResumeDetail.resumeDatas.workExperiences
                }
                setWorkExperiences(setResumeOtherData({
                    accountId: mRespResumeDetail.accountId,
                    resumeKey: OtherData_workExperiences,
                    resumeData: workExperiences
                }))
                var attachment
                if(mRespResumeDetail.resumeDatas !== undefined && mRespResumeDetail.resumeDatas.attachment !== undefined){
                    attachment = mRespResumeDetail.resumeDatas.attachment
                }
                setAttachment(setResumeOtherData({
                    accountId: mRespResumeDetail.accountId,
                    resumeKey: OtherData_attachment,
                    resumeData: attachment
                }))
                var payrollMethod
                if(mRespResumeDetail.resumeDatas !== undefined && mRespResumeDetail.resumeDatas.payrollMethod !== undefined){
                    payrollMethod = mRespResumeDetail.resumeDatas.payrollMethod
                }
                setPayrollMethod(setResumeOtherData({
                    accountId: mRespResumeDetail.accountId,
                    resumeKey: OtherData_payrollMethod,
                    resumeData: payrollMethod
                }))


                //setOtherData(mRespResumeDetail.otherData)
                setIsLoading(false)
            },
            failure: (err) => {
                //console.log(err)
                setIsLoading(false)
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err.message,
                }).then(() => {
                    window.history.go(-1)
                })
            }
        })
    }

    function setResumeOtherData({ accountId, resumeKey, resumeData }) {
        if (resumeData === undefined) {
            return new RespResumeOtherData({
                accountId,
                resumeKey
            })
        }
        return resumeData
    }

    async function toSave(birthday) {
        /*
        var mReqResumeEdit = new ReqResumeEdit({
            accountId,
            birthday
        })
        try {
            await api_contractorResumeUpdate({ mReqResumeEdit })
            console.log("OK")
        } catch (error) {
            console.log(error)
        }
        */
    }

    function toEdit() {
        window.location.assign("/EmployeeResumeEdit/" + id);
    }

    function toDetial() {
        window.location.assign("/EmployeeResumeDetail/" + id);
    }

    return (
        <>
            <EmployeeResumeJobInfo detail={detail} />
            <ContractorResumeBase
                rId={accountId}
                idN={idNumber}
                bDay={birthday}
                base={base}
                companyId={companyId}
                setIsLoading={setIsLoading}
                toSave={toSave}
                toEdit={toEdit}
                isEdit={isEdit}
                isEmployee={true}
                toDetial={toDetial}
            />
            <ContractorResumeFamily
                rId={accountId}
                familys={family}
                companyId={companyId}
                setIsLoading={setIsLoading}
                isEdit={isEdit}
                isEmployee={true}
                toDetial={toDetial}
            />
            <ContractorResumeEducation
                rId={accountId}
                education={education}
                companyId={companyId}
                setIsLoading={setIsLoading}
                isEdit={isEdit}
                isEmployee={true}
                toDetial={toDetial}
            />
            <ContractorResumeWorkExperiences
                rId={accountId}
                workExperiences={workExperiences}
                companyId={companyId}
                setIsLoading={setIsLoading}
                isEdit={isEdit}
                isEmployee={true}
                toDetial={toDetial}
            />
            <ContractorResumeAttachment
                rId={accountId}
                attachment={attachment}
                companyId={companyId}
                setIsLoading={setIsLoading}
                isEdit={isEdit}
                isEmployee={true}
                toDetial={toDetial}
            />
            <ContractorResumePayrollMethod
                rId={accountId}
                payrollMethod={payrollMethod}
                companyId={companyId}
                setIsLoading={setIsLoading}
                isEdit={isEdit}
                isEmployee={true}
                toDetial={toDetial}
            />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}